<div class="summary-part"
     *ngIf="!cs.step1.skipped">
    <div class="summary-part-title">
        <div class="title">{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP1.TAB' | translate }}</div>
        <div class="action"
             (click)="gotoStep(0)">{{ 'BUTTON.MODIFY' | translate }}</div>
    </div>
    <ng-container *ngIf="cs.step1.valid">
        <div class="summary-part-row">
            <div class="summary-field label">{{ 'ITSM.CREATECASEPOPIN.TITLE' | translate }}</div>
            <div class="summary-field value">
                {{ cs.step1.title }}
            </div>
        </div>
        <div class="summary-part-row">
            <div class="summary-field label">{{ 'ITSM.CREATECASEPOPIN.CATEGORY' | translate }}</div>
            <div class="summary-field value">
                {{ cs.step1.catalogEntry.path[this.language] }}
            </div>
        </div>
        <div class="summary-part-row">
            <div class="summary-field label">{{ 'ITSM.LIST.TABLE.URGENCY' | translate }}</div>
            <div class="summary-field value">
                {{ this.labelKey | translate }}
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!cs.step1.valid">
        <div class="summary-part-row">
            {{ 'ITSM.CREATESERVICEREQUEST.STEPS.NOTCOMPLETED' | translate }}
        </div>
    </ng-container>
    <hr />
</div>
